module.exports = __webpack_public_path__ + "253fec88833c1e5567c676ecf9dcdb04.fbx";